import {useEffect, useState} from 'react';
import {Card, Table, Row} from 'antd';
import {ProductSearchWidget} from "../fulfillment/ProductSearchWidget";
import {TrashWidget} from "../widget/TrashWidget";
import {insertPlantProduct, deletePlantProduct, getPlantProducts} from "../../api/Api";

export const WholesaleProductsCard = ({strainId, onApiFail, refresh, onRefresh, props}) => {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        getPlantProducts(strainId).then(result => {
            setProducts(result.map((r, index) => {
                return {
                    ...r,
                    key: index
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [strainId, refresh, onApiFail])
    const onSelect = (item) => {
        insertPlantProduct(strainId, item.id).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const onDelete = (record) => () => {
        deletePlantProduct(strainId, record.productId).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Delete',
            dataIndex: 'id',
            key: 'delete',
            render: (val, record, index) => {
                return <TrashWidget onDelete={onDelete(record)} />
            }
        }
    ]

    const cardStyle = {textAlign: 'left'}

    return <Card style={cardStyle} title={<b>Harvest Products</b>}>
        {products.length > 0 &&
            <Table columns={columns} dataSource={products} pagination={false} />
        }
        <Row style={{margin:'10px'}}>
            <b>Add new product:</b>
        </Row>
        <ProductSearchWidget onSelect={onSelect} onApiFail={onApiFail} refresh={refresh} type={"wholesale"} />
    </Card>
}